/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Translation_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "Do you want to delete this translation file? This action cannot be undone." |
*
* @param {Delete_Translation_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_translation_confirm_text = /** @type {((inputs?: Delete_Translation_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Translation_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voulez-vous supprimer ce fichier de traduction ? Cette action est irréversible.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie diese Übersetzungsdatei löschen? Diese Aktion kann nicht rückgängig gemacht werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vuoi eliminare questo file di traduzione? Questa azione non può essere annullata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы хотите удалить этот файл перевода? Это действие необратимо.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quieres eliminar este archivo de traducción? Esta acción no se puede deshacer.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是否删除此翻译文件？此操作无法撤销。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この翻訳ファイルを削除しますか? この操作は元に戻せません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप इस अनुवाद फ़ाइल को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deseja excluir este arquivo de tradução? Esta ação não pode ser desfeita.")
	return /** @type {LocalizedString} */ ("Do you want to delete this translation file? This action cannot be undone.")
});